import { useMemo, useState } from "react";
import { Info } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/Reveal";
import ServiceCard from "@/components/ServiceCard";
import { SERVICES } from "@/data/site";

const FILTERS = [null, 45, 60, 90, 120];

export default function Services() {
  const [filter, setFilter] = useState(null);

  const visible = useMemo(
    () => (filter ? SERVICES.filter((s) => s.durations.some((d) => d.mins === filter)) : SERVICES),
    [filter]
  );

  return (
    <main data-testid="services-page" className="pb-16 md:pb-0">
      <Seo
        title="Massage Services & Prices | Belong Saloon & Spa, Hyderabad"
        description="Explore 7 massage rituals — aroma therapy, Balinese, deep tissue, Thai, four hand, full body massage & Jacuzzi spa. 45–120 min sessions in Suchitra, Hyderabad."
      />

      <section className="mx-auto max-w-7xl px-5 pb-10 pt-40 sm:px-8">
        <Reveal>
          <Eyebrow className="mb-4">Services</Eyebrow>
          <h1 className="max-w-3xl font-serif-display text-4xl leading-tight text-cream sm:text-6xl">
            Choose your <span className="italic text-gold-gradient">service</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone-400">
            Seven body therapies, one address. Filter by the time you have — every session includes consultation,
            fresh linen and a private suite.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-10">
          <div data-testid="duration-filters" className="flex flex-wrap gap-3">
            {FILTERS.map((f) => (
              <button
                key={f ?? "all"}
                data-testid={f ? `duration-chip-${f}` : "duration-chip-all"}
                onClick={() => setFilter(f)}
                className={`rounded-full border px-5 py-2.5 text-sm font-semibold transition-all duration-300 active:scale-[0.97] ${
                  filter === f
                    ? "border-gold bg-gold text-stone-950"
                    : "border-gold/25 text-stone-300 hover:border-gold/60 hover:text-gold"
                }`}
              >
                {f ? `${f} min` : "All services"}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-6">
          <div data-testid="duration-notice" className="flex items-start gap-3 rounded-2xl border border-copper/30 bg-copper/10 px-5 py-4 text-sm text-stone-300">
            <Info size={17} className="mt-0.5 shrink-0 text-copper" />
            <p>
              <span className="font-semibold text-copper">A note on durations:</span> Four Hand Massage and
              Jacuzzi Spa begin at 60 minutes (60 / 90 / 120 min). All other services are available in
              45 / 60 / 90 / 120-minute sessions. Call or WhatsApp 098666 34473 for current pricing and offers.
            </p>
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 pb-28 sm:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>
      </section>
    </main>
  );
}
